import {
  Card,
  Title,
  Subtitle,
  LineChart,
  Table,
  TableHead,
  TableRow,
  TableHeaderCell,
  TableBody,
  TableCell,
  Badge,
} from "@tremor/react";
import { LineChart as LineChartIcon } from "lucide-react";
import { SectionHeader } from "@/components/ui/SectionHeader";
import { TableScroll } from "@/components/ui/TableScroll";
import { mediaInWindow } from "@/data/derived";
import { useFilterVersion } from "@/data/filters";
import { eur, eurAxis, formatLunaKey, procent } from "@/lib/format";

// Etichete prietenoase pentru legendă/tooltip (în loc de nume tehnice de coloană).
const CAT_COST = "Cost/oră";
const CAT_MA6 = "Medie 6 luni";
const CAT_MA12 = "Medie 12 luni";

export function MediaMobilaSection() {
  useFilterVersion();
  const randuri = mediaInWindow();
  const chartData = randuri.map((r) => ({
    luna: formatLunaKey(r.luna_key),
    [CAT_COST]: r.cost_pe_ora_eur,
    [CAT_MA6]: r.ma_6l,
    [CAT_MA12]: r.ma_12l,
  }));

  return (
    <section>
      <SectionHeader
        id="media-mobila"
        icon={LineChartIcon}
        titlu="2. Media mobilă cost producție (1 / 6 / 12 luni)"
        descriere="Semnal sub/peste medie — detectează derapaj de cost înainte să devină problemă de marjă."
      />
      <Card className="ring-slate-200">
        <Title>Cost /oră vs. medii mobile</Title>
        <Subtitle>MA6 și MA12 netezesc fluctuațiile lunare pentru trend real</Subtitle>
        <LineChart
          className="mt-4 h-80 w-full"
          data={chartData}
          index="luna"
          categories={[CAT_COST, CAT_MA6, CAT_MA12]}
          colors={["blue", "amber", "emerald"]}
          valueFormatter={eurAxis}
          curveType="monotone"
          yAxisWidth={64}
          noDataText="Fără date"
        />
      </Card>

      <Card className="mt-4 ring-slate-200">
        <Title>Detaliu lunar + semnal</Title>
        <Subtitle>Deviația față de media pe 6 luni marchează lunile cu cost peste trend</Subtitle>
        <TableScroll minWidth="44rem">
          <Table className="mt-3">
            <TableHead>
              <TableRow className="border-slate-200">
                <TableHeaderCell>Lună</TableHeaderCell>
                <TableHeaderCell className="text-right">Cost/oră</TableHeaderCell>
                <TableHeaderCell className="text-right">MA6</TableHeaderCell>
                <TableHeaderCell className="text-right">MA12</TableHeaderCell>
                <TableHeaderCell className="text-right">Deviație vs MA6</TableHeaderCell>
                <TableHeaderCell>Semnal</TableHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {randuri.map((r) => (
                <TableRow key={r.luna_key} className="border-slate-100">
                  <TableCell className="font-medium text-slate-700">{formatLunaKey(r.luna_key)}</TableCell>
                  <TableCell className="text-right tabular">{eur(r.cost_pe_ora_eur, 0)}</TableCell>
                  <TableCell className="text-right tabular text-slate-500">{eur(r.ma_6l, 0)}</TableCell>
                  <TableCell className="text-right tabular text-slate-500">{eur(r.ma_12l, 0)}</TableCell>
                  <TableCell className="text-right tabular">{procent(r.deviatie_pct_ma6)}</TableCell>
                  <TableCell>
                    <Badge color={r.semnal_vs_ma6 === "PESTE_MEDIE" ? "rose" : "emerald"} size="xs">
                      {r.semnal_vs_ma6 === "PESTE_MEDIE" ? "Peste medie" : "Sub medie"}
                    </Badge>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableScroll>
      </Card>
    </section>
  );
}
